/* eslint-disable react/require-default-props */
import React from 'react';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import { Container, Card } from './styles';

type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
};

const RegisterStatusCard = ({ title, subtitle, children }: Props) => (
  <Container>
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Card>
            <div className="content text-center">
              <img className="logo" src={Logo} alt="ConLicitação" />

              <h2 className="title">{title}</h2>

              {subtitle ? <p className="subtitle">{subtitle}</p> : null}

              {children ? <div className="actions">{children}</div> : null}
            </div>
          </Card>
        </div>
      </div>
    </div>
  </Container>
);

export default RegisterStatusCard;
